import cms from './cms';

/** Key en data-store que devuelve array de precios que NO se consideran precio especial */
export const DATA_STORE_KEY_PRICES_NOT_SPECIAL = 'delete_has_not_special';

const PRICE_EPSILON = 0.005;

/**
 * Indica si un monto está dentro de la lista de precios permitidos (no especial).
 * Comparación con tolerancia para floats.
 */
export function isPriceInAllowedList(
  amount: number,
  allowedPrices: number[]
): boolean {
  return allowedPrices.some((p) => Math.abs(p - amount) < PRICE_EPSILON);
}

/**
 * True si el monto NO está en la lista de precios permitidos (es precio especial).
 * Única fuente de verdad para la lógica de "hasSpecialPrice".
 */
export function hasSpecialPrice(
  amount: number,
  allowedPrices: number[]
): boolean {
  if (!allowedPrices.length) return false;
  return !isPriceInAllowedList(amount, allowedPrices);
}

/**
 * Obtiene desde data-store la lista de precios que NO se consideran precio especial.
 * Si el endpoint falla, devuelve array vacío (ningún precio se considerará especial).
 */
export async function fetchPricesNotSpecial(): Promise<number[]> {
  try {
    const { data } = await cms.get<number[]>(
      `/v2/data-store/${DATA_STORE_KEY_PRICES_NOT_SPECIAL}`
    );
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching prices not special from data-store:', error);
    return [];
  }
}
